/**
 *  SanitairLuxe — Cart Drawer v2 JavaScript
 *  Handles: AJAX add-to-cart for recommendation/cross-sell cards,
 *  variant selector changes, cross-sell carousel navigation,
 *  and cart drawer refresh after additions.
 */

(function() {
  'use strict';

  /* -------------------------------------------------------
   * Variant selector change handler
   * When a user changes a variant option dropdown in a
   * recommendation card, find the matching variant and
   * update the ATC button + price display
   * ------------------------------------------------------- */
  function initVariantSelectors(container) {
    const cards = container.querySelectorAll('.sl-cart-rec-card');
    cards.forEach(function(card) {
      const selects = card.querySelectorAll('.sl-cart-rec-card__variant-select');
      const jsonEl = card.querySelector('.sl-cart-rec-card__variants-json');
      if (!jsonEl || selects.length === 0) return;

      let variants;
      try {
        variants = JSON.parse(jsonEl.textContent);
      } catch(e) {
        return;
      }

      selects.forEach(function(select) {
        select.addEventListener('change', function() {
          // Gather current selected options
          const selectedOptions = [];
          card.querySelectorAll('.sl-cart-rec-card__variant-select').forEach(function(s) {
            selectedOptions.push(s.value);
          });

          // Find matching variant
          const matchedVariant = variants.find(function(v) {
            return v.options.every(function(opt, i) {
              return opt === selectedOptions[i];
            });
          });

          const atcBtn = card.querySelector('.sl-cart-rec-card__atc-btn');
          const priceEl = card.querySelector('.sl-cart-rec-card__price');

          if (matchedVariant) {
            atcBtn.dataset.variantId = matchedVariant.id;
            atcBtn.dataset.available = matchedVariant.available;

            if (matchedVariant.available) {
              atcBtn.disabled = false;
              atcBtn.textContent = atcBtn.closest('.sl-cart-drawer__sidebar')
                ? (window.theme && window.theme.strings && window.theme.strings.addToCart || 'In winkelwagen')
                : (window.theme && window.theme.strings && window.theme.strings.addToCart || 'In winkelwagen');
            } else {
              atcBtn.disabled = true;
              atcBtn.textContent = window.theme && window.theme.strings && window.theme.strings.soldOut || 'Uitverkocht';
            }

            // Update price
            if (priceEl) {
              let priceHTML = '';
              if (matchedVariant.compare_at_price) {
                priceHTML += '<del>' + matchedVariant.compare_at_price + '</del> ';
              }
              priceHTML += matchedVariant.price;
              priceEl.innerHTML = priceHTML;
            }
          }
        });
      });
    });
  }

  /* -------------------------------------------------------
   * AJAX Add to Cart for recommendation/cross-sell cards
   * ------------------------------------------------------- */
  function initAddToCartButtons(container) {
    const buttons = container.querySelectorAll('.sl-cart-rec-card__atc-btn');
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        if (btn.disabled || btn.classList.contains('sl-loading')) return;

        const variantId = btn.dataset.variantId;
        if (!variantId) return;

        btn.classList.add('sl-loading');
        const originalText = btn.textContent;
        btn.textContent = '...';

        const body = JSON.stringify({
          items: [{
            id: parseInt(variantId, 10),
            quantity: 1
          }]
        });

        fetch(window.Shopify && window.Shopify.routes
          ? (window.Shopify.routes.root || '/') + 'cart/add.js'
          : '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: body
        })
        .then(function(response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function() {
          btn.textContent = '✓';
          // Refresh the cart drawer
          refreshCartDrawer();
          // Reset button after a moment
          setTimeout(function() {
            btn.textContent = originalText;
            btn.classList.remove('sl-loading');
          }, 1200);
        })
        .catch(function(err) {
          console.error('SL Cart Drawer: Add to cart error', err);
          btn.textContent = originalText;
          btn.classList.remove('sl-loading');
        });
      });
    });
  }

  /* -------------------------------------------------------
   * Refresh cart drawer (re-fetch sections)
   * ------------------------------------------------------- */
  function refreshCartDrawer() {
    const cartDrawer = document.getElementById('Cart-Drawer');
    if (!cartDrawer) return;

    // Trigger the built-in cart:refresh event
    document.dispatchEvent(new CustomEvent('cart:refresh'));

    // Also dispatch for external listeners
    if (typeof dispatchCustomEvent === 'function') {
      dispatchCustomEvent('line-item:change:end', { quantity: 1 });
    }
  }

  /* -------------------------------------------------------
   * Cross-sell carousel navigation
   * ------------------------------------------------------- */
  function initCarouselNavigation(container) {
    const prevBtns = container.querySelectorAll('.sl-crosssell__arrow--prev');
    const nextBtns = container.querySelectorAll('.sl-crosssell__arrow--next');

    prevBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const carousel = btn.closest('.sl-crosssell__carousel-wrapper').querySelector('.sl-crosssell__carousel');
        if (carousel) {
          carousel.scrollBy({ left: -220, behavior: 'smooth' });
        }
      });
    });

    nextBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const carousel = btn.closest('.sl-crosssell__carousel-wrapper').querySelector('.sl-crosssell__carousel');
        if (carousel) {
          carousel.scrollBy({ left: 220, behavior: 'smooth' });
        }
      });
    });
  }

  /* -------------------------------------------------------
   * Initialize everything
   * ------------------------------------------------------- */
  function init() {
    const drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;

    initVariantSelectors(drawer);
    initAddToCartButtons(drawer);
    initCarouselNavigation(drawer);
  }

  /* -------------------------------------------------------
   * Re-init after cart drawer content is replaced
   * (after AJAX section rendering)
   * ------------------------------------------------------- */
  function observeCartDrawer() {
    const drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;

    const observer = new MutationObserver(function(mutations) {
      // Debounce re-init
      clearTimeout(observer._timeout);
      observer._timeout = setTimeout(function() {
        init();
      }, 100);
    });

    observer.observe(drawer, {
      childList: true,
      subtree: true
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      init();
      observeCartDrawer();
    });
  } else {
    init();
    observeCartDrawer();
  }

})();
